import { FC } from 'react';
import { FileText } from 'lucide-react';

interface ExampleFileLinkProps {
  url: string;
  label?: string;
}

export const ExampleFileLink: FC<ExampleFileLinkProps> = ({ url, label = 'View Example File' }) => {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-2 text-(--primary-O900) hover:underline [font-size:var(--fs-p4)]!"
    >
      <FileText size={16} />
      {label}
    </a>
  );
};
